/* eslint-disable no-unused-vars */
export enum UIPageContainerVariants {
  full = 'full',
  wide = 'wide',
};
